// Import Libraries
import { isPointWithinRadius, orderByDistance } from 'geolib';
// Import Utils
import { getMeters } from '../convertDistance';

// -> FIND NEARBY HOTELS BY MAP COORDINATES
const getNearbyHotels = (hotels, location, radius) => {

	// Map option variable
	let locationFilteredHotels = [];

  // All filtered hotel arrays will go in here
	let allFilteredHotels = [];

	// FIRST GET RADIUS
	// Check if radius field isn't empty, if it is default to 50 miles
	let searchRadius = radius ? radius : 50;
	// Conver to meters (geolib needs meters)
	searchRadius = getMeters(searchRadius);
	
	// REMOVE ANY HOTELS / PAGES THAT HAVE NO COORDINATES
	let hotelsOrPages = [];
	if(hotels[0]._type === 'hotel') {
		hotels.filter(hotel => hotel.location ? hotelsOrPages.push(hotel) : false)
	} else {
		hotels.filter(hotel => hotel.mapSearchOptions ? hotelsOrPages.push(hotel) : false)
	}
	// Loop through all hotels & get all coordinates that meet requirements and put in array e.g., id, {coords}
	hotelsOrPages.forEach((hotel) => {

	let hotelLocation
		if (hotel._type === 'hotel' || hotel._type === 'attraction') {
			hotelLocation = hotel.location;
		} else if (hotel._type === 'pillar') {
			hotelLocation = hotel.mapSearchOptions.filterByLocation;
		}

		// if hotel has no coordinates then skip hotel
		if (!hotelLocation || !hotelLocation.lat) {
			return null;
		}
		// Check that hotel is within radius of pillar pages search map coordinates
		let hotelWithinRadius = isPointWithinRadius(
      hotelLocation,
			location,
			searchRadius
		);

    if (hotelWithinRadius) {
			// Place into array as new object with lat, lng & id so we can later orderByDistance
			locationFilteredHotels.push({
				lat: hotelLocation.lat,
				lng: hotelLocation.lng,
				id: hotel._id,
			});
		}

		// if true push into an array we define at top
	});

  // orderByDistance (geolib) to get hotels in ascending order of distance (closest is first)
  const orderedLocationsByDistance = orderByDistance(
    location,
    locationFilteredHotels
  );

  // Save all hotel Ids into our allFilteredHotels array
  allFilteredHotels = orderedLocationsByDistance.map((hotel) => hotel.id);

	// Return first 10 results
  // return allFilteredHotels.slice(0, 10)
  return allFilteredHotels;
};

export { getNearbyHotels };
